<template>
  <div class="signature">
    <nav class="navigation clearfix">
      <tabs :tabs="tabs" class="tabs" @selected="id => (tabId = id)" />
    </nav>
    <signature-draw v-if="tabId === 'draw'" :labels="labels" />
    <signature-type v-if="tabId === 'type'" :labels="labels" />
  </div>
</template>

<script>
import { Tabs } from 'vue-bootstrap';
import SignatureDraw from './SignatureDraw';
import SignatureType from './SignatureType';

export default {
  components: {
    Tabs,
    SignatureDraw,
    SignatureType
  },
  props: {
    labels: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tabId: 'draw',
      tabs: [
        { id: 'draw', name: this.labels.draw },
        { id: 'type', name: this.labels.type }
      ]
    };
  }
};
</script>

<style scoped>
.tabs {
  border-bottom: 0;
}
</style>
